import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import API from '../../../create/api';
import { useSelector, useStore } from 'react-redux';
import querystring from 'querystring';
import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import Company from '../../../fields/company';
import { updateLastCompanyAndClearParcelIds } from '../../../../store/thunk-actions';
import { type AnyAction } from 'redux';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
    '& .MuiTableCell-root': {
      border: '1px solid #e0e0e0',
      padding: '12px 16px',
    },
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiTableCell-root': {
        color: 'white',
        fontWeight: 600,
      },
    },
    '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  filterRow: {
    backgroundColor: '#f5f5f5',
    '& .MuiTableCell-root': {
      borderBottom: '2px solid #e0e0e0',
    },
  },
  newPaymentButton: {
    marginBottom: theme.spacing(2),
    padding: '10px 20px',
    fontWeight: 'bold',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  },
  paymentAmount: {
    fontWeight: 'bold',
    color: theme.palette.success.dark,
  },
}));

function PaymentIndex(props: any) {
  const classes = useStyles();
  const history = useHistory();
  const store = useStore();

  // first fetch
  const [get_payments, set_payments] = useState([]);
  const currentCompany = useSelector((state: any) => state?.parcel?.last_company);

  // table filter
  function getParcel() {
    const param = querystring.encode(_.pickBy({ company: currentCompany?.value, _sort: 'id:DESC' }, _.identity));
    const url = `${process.env.REACT_APP_API_SERVER}/payments?${param}`;
    API.getAll(url).then((payments: any) => {
      set_payments(payments);
    });
  }
  useEffect(() => {
    getParcel();
  }, [currentCompany]);

  return (
    <Grid container>
      <Grid item xs={3} className={classes.createButton}>
        <Button
          variant="contained"
          color="primary"
          className={classes.newPaymentButton}
          startIcon={
            <IconButton
              onClick={() => {
                history.push('/dashboard/parcel/create');
              }}
              color="inherit"
            >
              <AddCircleIcon />
            </IconButton>
          }
          onClick={() => props.history.push('/dashboard/payment/create')}
        >
          New Payment
        </Button>
      </Grid>
      <Grid item xs={12} className={classes.createButton}>
        <TableContainer component={Paper} elevation={3}>
          <Table className={classes.table} aria-label="payments table" size="medium">
            <TableHead>
              <TableRow className={classes.filterRow}>
                <TableCell>Company</TableCell>
                <TableCell colSpan={2}>
                  <Company
                    defaultValue={currentCompany}
                    onChange={(company: any) => {
                      store.dispatch(updateLastCompanyAndClearParcelIds(company) as unknown as AnyAction);
                    }}
                  />
                </TableCell>
                <TableCell colSpan={11}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Date</TableCell>
                <TableCell align="left">Company</TableCell>
                <TableCell align="center">Methods</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="left">Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {get_payments.length > 0 ? (
                get_payments.map((row: any) => (
                  <TableRow
                    key={row.id}
                    onClick={() => {
                      history.push(`/dashboard/paymentshow/${row.id}`);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>
                      <strong>#{row.id}</strong>
                    </TableCell>
                    <TableCell>{moment(row.created_at).format('DD/MMM/YY')}</TableCell>
                    <TableCell align="left">{row.company?.name}</TableCell>
                    <TableCell align="center">
                      <span
                        style={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          backgroundColor: '#e3f2fd',
                          color: '#0d47a1',
                          fontWeight: 500,
                        }}
                      >
                        {row.paymentMethod ?? 'N/A'}
                      </span>
                    </TableCell>
                    <TableCell align="right" className={classes.paymentAmount}>
                      {row.amount?.toLocaleString()}
                    </TableCell>
                    <TableCell align="left">
                      {row.note ? row.note : <em style={{ color: '#9e9e9e' }}>No notes</em>}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" style={{ padding: '30px' }}>
                    <div style={{ color: '#9e9e9e' }}>
                      <div style={{ fontSize: '20px', marginBottom: '10px' }}>No payment records found</div>
                      <div>Try selecting a different company or add a new payment</div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default withRouter(PaymentIndex);
